"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var hooks_1 = require("../../../hooks");
var store_1 = require("../../../store");
var response_1 = require("../../response");
var dependency_1 = require("../dependency");
var queryFunctions_1 = require("../queryFunctions");
var useCurrentDependencies_1 = require("../useCurrentDependencies");
var useQueryLifecycle_1 = require("../useQueryLifecycle");
function useBulkQuery(_a) {
    var options = _a.options, method = _a.method, wait = _a.wait;
    var store = store_1.useStoreContext().store;
    var _b = __read(React.useState(), 2), pollingInterval = _b[0], setPollingInterval = _b[1];
    var currentDependencies = useCurrentDependencies_1.default(method, options);
    var pollDependencies = React.useCallback(function () {
        // don't make the calls if we need to wait
        if (wait)
            return;
        currentDependencies.forEach(function (dependency) {
            return dependency_1.pollDependency(dependency, store, setPollingInterval, options.caching.pollUntil);
        });
    }, [currentDependencies, wait]);
    React.useEffect(function () {
        setPollingInterval(queryFunctions_1.getPollingInterval(options));
    }, [JSON.stringify(options.caching)]);
    hooks_1.useInterval(pollDependencies, pollingInterval);
    var call = React.useCallback(function (dependency) {
        dependency_1.callDependency(dependency, store, setPollingInterval);
    }, [store, setPollingInterval]);
    var refresh = useQueryLifecycle_1.default({
        call: call,
        wait: wait,
        dependencies: currentDependencies,
    });
    var results = React.useMemo(function () {
        return currentDependencies.map(function (currentDep) {
            return queryFunctions_1.processVariant(currentDep.currentState.variant);
        });
    }, [currentDependencies]);
    var aggregatedResults = React.useMemo(function () {
        if (wait)
            return { loading: true, error: false };
        return response_1.aggregateResults(results);
    }, [results]);
    return { results: results, refresh: refresh, aggregatedResults: aggregatedResults };
}
exports.default = useBulkQuery;
//# sourceMappingURL=useBulkQuery.js.map